import { Box, Typography, styled } from '@mui/material'
import React from 'react'
import { useChatContex } from '../../contex/ChatContex'




const Imagecontainer=styled(Box)`
display:flex;
justify-content:center;
`
const BoxWraper=styled(Box)`
background:#FFF;
padding: 12px 30px 2px;
box-shadow:0 1px 3px rgba(0,0,0,0.08);
& :first-child{
  font-size:13px;
  color:#009688;
  font-weight:200
}
& :last-child{
  margin:14px 0;
  color:#4A4A4A;
}


`
const DescriptionContainer=styled(Box)`
padding: 15px 20px 28px 30px;
& > p{
font-size:13px;
color:#8696a0;
}
`
const Image=styled("img")({
width:200,
height:200,
borderRadius:"50%",
padding:"25px 0"
})






function Profile() {
    const {login}=useChatContex()

  
    return (
        <div>
            <Imagecontainer>
                <Image src={login.picture}></Image>
            </Imagecontainer>
            <BoxWraper>
                <Typography>Your name</Typography>
                <Typography>{login.name}</Typography>
            </BoxWraper>
            <DescriptionContainer>
                <Typography>This is not your username or pin. This name will bw visible to your Whatsup contacts.</Typography>
            </DescriptionContainer>
            <BoxWraper>
                <Typography>About</Typography>
                <Typography>Eat! Sleep! Code! Repeate!</Typography>
            </BoxWraper>
        </div>
    )
}

export default Profile
